import { getPhoneNumber } from './common.js'
export default {
  init() {

    window.addEventListener('load', (event) => {
      var phoneNumber = getPhoneNumber();
      if(phoneNumber){
        $(`.branches-phone-mask`).prop('href', "tel:"+phoneNumber);
        $(`.branches-phone-mask-div`).attr("onclick", "location.href='tel:"+phoneNumber+"'");
      }


    });
    $(".info_section_form").css("display", "none");


  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/branches.js